
(function () {
  if (customElements.get('dynamic-section')) return;

  const ROOT_MARGIN = '300px';

  class DynamicSection extends HTMLElement {
    connectedCallback() {
      this.sectionName = this.dataset.sectionName;
      if (!this.sectionName || this.loaded) return;

      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) this.load();
        },
        { rootMargin: ROOT_MARGIN },
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.controller?.abort();
      this.controller = null;
    }

    async load() {
      if (this.loaded) return;
      this.loaded = true;
      this.observer?.disconnect();
      this.observer = null;

      const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const url = `${base}?section_id=${encodeURIComponent(this.sectionName)}`;
      this.controller = new AbortController();

      try {
        const res = await fetch(url, { signal: this.controller.signal });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const html = await res.text();
        this.innerHTML = html;
        // Re-init app.js-driven markup; nested custom elements upgrade themselves.
        this.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      } catch (err) {
        if (err.name === 'AbortError') return;
        this.loaded = false; // allow a retry on reconnect
        console.error(`[dynamic-section] failed to load "${this.sectionName}"`, err);
      } finally {
        this.controller = null;
      }
    }
  }

  customElements.define('dynamic-section', DynamicSection);
})();
